var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Supervisor as SupervisorModel } from '@/models/Supervisor';
import PageHeader from '@/components/page-header/PageHeader';
import { fileToBase64, formatDate } from '@/support/String';
import DataTable from '@/components/data-table/DataTable';
import { Token } from '@/support/Token';
import ImageInput from '@/components/dialog/image-input/ImageInput';
import ErrorHandler from '@/support/ErrorHandler';
import { RolesEnum } from '@/items/Roles';
import ConfirmRemoveMfaDialog from '@/components/ConfirmRemoveMfaDialog/ConfirmRemoveMfaDialog.vue';
let Supervisor = class Supervisor extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Supervisor';
        this.isEditing = false;
        this.isEditingDob = false;
        this.formatDob = formatDate;
        this.supervisor = new SupervisorModel();
        this.file = null;
        this.baseImage = null;
        this.isChangingAvatar = false;
        this.passwordHidden = true;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
        // #region RemoveMFA
        this.isConfirmRemoveMfaDialogOpen = false;
        // #endregion
    }
    get breadcrumbs() {
        return [
            { name: this.$tc('roles.user', 2) },
            { name: this.$tc('roles.supervisor', 2), path: '/supervisors' },
            { name: this.supervisor.name || '', path: this.$route.path },
        ];
    }
    mounted() {
        new SupervisorModel()
            .include('token')
            .find(this.$route.params.id)
            .then((supervisor) => {
            this.supervisor = supervisor;
        });
    }
    update() {
        this.isEditing = false;
        if (this.password.new.length === 0) {
            this.resetPassword();
        }
        else {
            this.supervisor.password = this.password.new;
        }
        const payload = this.supervisor.getPayload();
        if (payload.avatar) {
            delete payload.avatar;
        }
        this.supervisor
            .include(['supervisor', 'roles'])
            .update(payload)
            .then((supervisor) => {
            this.resetPassword();
            this.supervisor = supervisor;
            this.updateCurrentUser(supervisor);
        });
    }
    resetPassword() {
        delete this.supervisor.password;
        delete this.supervisor.current_password;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
    }
    updateCurrentUser(supervisor) {
        if (supervisor.id === this.$store.state.Auth.id) {
            this.$store.dispatch('userAuthenticated', supervisor);
        }
    }
    setToken() {
        Token.setLoginAsToken(this.supervisor.token.bearer);
        const url = `${window.location.protocol}//${window.location.host}`;
        window.location.href = url;
    }
    changeAvatar(event) {
        if (event.target === null || event.target.files === null || !event.target.files.length) {
            return;
        }
        this.file = event.target.files[0];
        fileToBase64(this.file).then((encodedFile) => {
            this.baseImage = encodedFile;
            this.isChangingAvatar = true;
        });
    }
    async changingCurrentAvatar() {
        const supervisorWithDataObjects = await new SupervisorModel()
            .include(['data_objects'])
            .find(this.$route.params.id);
        if (supervisorWithDataObjects) {
            this.baseImage = supervisorWithDataObjects.data_objects.avatar;
            this.isChangingAvatar = true;
        }
    }
    avatarChanged(imageUrl) {
        this.supervisor
            .include(['supervisor', 'roles'])
            .update({ avatar: imageUrl })
            .then((supervisor) => {
            this.supervisor.avatar = imageUrl;
            this.updateCurrentUser(supervisor);
            this.$emit('closed', false);
            this.isChangingAvatar = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([
            RolesEnum.ADMIN,
            RolesEnum.ROOT,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
        ]);
    }
    get canRemoveMfa() {
        return this.$store.state.Auth.hasRole([RolesEnum.ROOT, RolesEnum.ADMIN]);
    }
    get removeMfaEnabled() {
        return !!this.supervisor.has_mfa_token;
    }
    async removeMfa() {
        if (this.supervisor) {
            const supervisor = await this.supervisor
                .update({ mfa_token: null })
                .catch((error) => {
                ErrorHandler.network(error);
                return null;
            });
            if (supervisor) {
                this.$set(this.supervisor, 'has_mfa_token', false);
            }
        }
        this.isConfirmRemoveMfaDialogOpen = false;
    }
};
Supervisor = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            ImageInput,
            ConfirmRemoveMfaDialog,
        },
    })
], Supervisor);
export default Supervisor;
